module.exports = __webpack_public_path__ + "static/media/image.4bcd91c4.jpg";